import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from './../../constants/axios';
import alert from 'alertify.js';
import InputControl from './../FormTemplate/InputControl';

class NewManufacturerForm extends React.Component {

   save = (values) => {
      return axios.post('manufacturers', values)
         .then((res) => {
            if (res.status === 201) {
               alert.success('New Created.');
               this.context.router.push('manufacturer');
            } else {
               alert.error('Something Went Wrong. Call Rasel');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      return (
         <div>
            <h3>New Manufacturer Form</h3>
            <form onSubmit={handleSubmit(this.save)} autoComplete="off" noValidate >
               <Field name="name" component={InputControl} type="text" label="Name" />

               <Button type="submit" bsStyle="success" block
                       disabled={submitting || pristine || invalid} >Save</Button>
            </form>
         </div>
      );
   }
}
NewManufacturerForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func
};

NewManufacturerForm.contextTypes = {
   router: PropTypes.object.isRequired
};

NewManufacturerForm = reduxForm({ // eslint-disable-line
   form: 'newManufacturerForm'
})(NewManufacturerForm);

export default NewManufacturerForm;



/** WEBPACK FOOTER **
 ** ./src/components/Manufacturer/NewManufacturerForm.js
 **/